// extracted by mini-css-extract-plugin
export default {"addToCartControl":"U0-z","giftCard":"V0-z","btnContainer":"W0-z","cartButton":"X0-z","disabled":"Y0-z"};